<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :images="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5"/>
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes"/>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class=""/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d985.9838052682587!2d115.21860682919004!3d-8.697701999609444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDEnNTEuNyJTIDExNcKwMTMnMDkuMCJF!5e0!3m2!1sen!2sid!4v1583429445682!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.697702,115.219154/@-8.697702,115.2186068,19z/data=!4m2!4m1!3e0"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/CETAK_A735680_udtUGPi8Q.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A731959_0Tlklk00W.jpg'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A732051_YBCLqmU6n.jpg'
const ImageHero4 = 'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/C_A735418_ALufkrCHw.jpg'

import Audio from "@/assets/audio/take-my-hand.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryTwo";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3, ImageHero4],
      bgActive: 0,
      dividerHeight: 0,
      location: "Jalan Raya Sesetan No 217/299, Denpasar Selatan, Denpasar - Bali",
      // date: "2020-04-05",
      time: {
        start: this.$moment("2020-04-05 11:00"),
        end: "Selesai"
      },
      wedding: {
        man: {
          name: 'Putu Krisna Yogaswara',
          surname: 'Yoga',
          parents: 'I Made Gede Arya Putra & Ni Wayan Ratna Wati',
          description: 'Putra pertama',
          address: 'Br. Lantang Bejuh, Denpasar - Bali',
        },
        woman: {
          name: 'Ni Putu Diah Puspita',
          surname: 'Diah',
          parents: 'I Ketut Gede Mandala & Kadek Sri Muliastini',
          address: 'Br. Gemeh, Denpasar - Bali',
          description: 'Putri pertama',
        },
      },
      mepandes: [
        'Arum Prihati',
        'Putu Krisna Yogaswara',
        'Ni Putu Intan Cahya Dewi',
        'Ni Made Dian Pradnyaswari',
        'I Made Febrian Ananda Putra',
        'Ni Komang Bintang Aishwarya Dewi',
      ],
      gallery: [
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A732051_YBCLqmU6n.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A735214_xKfdsryQAD.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A731959_0Tlklk00W.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A732076_wNa_2qKngo.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A732110_crNa89CJq.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A735465_ObrZxuS2ok.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A735634_ZuFqlwjgU.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A735703_biL_rf6H8.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/C_A735379_gxG1BIyYUA.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/_A735835_aemukk1Jp.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/C_A735418_ALufkrCHw.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/yoga-diah/CETAK_A735680_udtUGPi8Q.jpg',
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
